import { render } from "./ProfileFormModal.vue?vue&type=template&id=f01f4b4a"
import script from "./ProfileFormModal.vue?vue&type=script&lang=js"
export * from "./ProfileFormModal.vue?vue&type=script&lang=js"

import exportComponent from "/home/wildan/Projects/assets-tracker-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__